import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { AddressModel } from 'src/app/models/address.model';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';

@Component({
  selector: 'app-address-selector-question',
  templateUrl: './address-selector-question.component.html',
  styleUrls: ['./address-selector-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class AddressSelectorQuestionComponent implements OnInit {
  @Input() question: QQQuestionViewModel;
  value: AddressModel;
  prefix: string;

  constructor() { }

  ngOnInit() {
    const prefix = this.question.options.Prefix;
    const answers = this.question.page.questionnaire.answersObject;

    if (answers[`${prefix}Street`]) {
      this.value = new AddressModel({
        buildingNumber: answers[`${prefix}BuildingNumber`],
        subBuilding: answers[`${prefix}SubBuilding`],
        buildingName: answers[`${prefix}BuildingName`],
        street: answers[`${prefix}Street`],
        city: answers[`${prefix}City`],
        county: answers[`${prefix}County`],
        country: answers[`${prefix}Country`],
        postCode: answers[`${prefix}PostCode`]
      });
    }
  }

  async save(value: AddressModel) {
    this.question.error = null;

    const prefix = this.question.options.Prefix;

    const saveAnswer = (key: string, value: string) => this.question.page.questionnaire.saveAnswer(`${prefix}${key}`, value);

    saveAnswer("BuildingNumber", value?.buildingNumber);
    saveAnswer("SubBuilding", value?.subBuilding);
    saveAnswer("BuildingName", value?.buildingName);
    saveAnswer("Street", value?.street);
    saveAnswer("City", value?.city);
    saveAnswer("County", value?.county);
    saveAnswer("Country", value?.country);
    saveAnswer("PostCode", value?.postCode);
  }

}
